import React from 'react';
import { Box, Button, Divider, Typography, IconButton, Fade, Modal, Grid, Paper } from '@mui/material';
import WorkIcon from '@mui/icons-material/Work';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import CloseIcon from '@mui/icons-material/Close';

const OpportunityModal = ({ open, onClose, opportunity }) => {
  if (!opportunity) return null;

  const {
    opportunityOverview,
    roleDetails,
    compensationAndDates,
    // contactInformation
  } = opportunity;

  // Format date (fallback to 'N/A' if undefined)
  const formatDate = (date) => {
    return date ? new Date(date).toLocaleDateString() : 'N/A';
  };

  return (
    <Modal open={open} onClose={onClose} closeAfterTransition>
      <Fade in={open}>
        <Box sx={{
          width : { xs: '90%', sm: '70%', md: '55%' },
          maxHeight : '90vh',
          overflowY: 'auto',
          bgcolor: 'background.paper',
          p: 4,
          borderRadius: 4,
          mx: 'auto',
          mt: 6,
          boxShadow: 10,
          position: 'relative'
        }}>
         {/* Close Button */}
         <IconButton
          onClick={onClose}
          sx={{
            position: 'absolute',
            top : 16,
            right : 16,
            bgcolor: '#f5f5f5',
            '&:hover': { bgcolor: '#e0e0e0' },
          }}
          >
          <CloseIcon />
          </IconButton>
          {/* Title */}
          <Typography variant="body" fontWeight="400" textAlign="start" color="#043885" gutterBottom fontSize="1.4rem">
            {opportunityOverview?.title || 'N/A'}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Role Details Grid */}
          <Paper elevation={1} sx={{ p: 2, borderRadius: 2, mb: 3 }}>
            <Grid container spacing={2}>
              {[
                {
                label: 'Duration',
                value: opportunityOverview?.duration || 'N/A'
              },
                {
                label: 'Role Overview',
                value: roleDetails?.roleOverview || 'N/A'
              }, {
                label: 'Responsibilities',
                value: roleDetails?.responsibilities || 'N/A'
              }, {
                label: 'Deliverables',
                value: roleDetails?.deliverables || 'N/A'
              }, {
                label: 'Skills Required',
                value: roleDetails?.skills?.join(', ') || 'N/A'
              }, {
                label: 'Preferred Background',
                value: roleDetails?.preferredBackground || 'N/A'
              }].map((item, idx) => (
                <Grid item xs={12} key={idx}>
                  <Typography variant="subtitle2" fontWeight="bold" color="text.primary">{item.label}</Typography>
                  <Typography variant="body2" color="text.secondary">{item.value}</Typography>
                </Grid>
              ))}
            </Grid>
          </Paper>

          {/* Compensation & Deadline */}
          <Grid container spacing={2} mb={3}>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                <WorkIcon fontSize="small" sx={{ mr: 1 }} />
                Compensation
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {compensationAndDates?.stipendOrSalary || 'Unpaid'}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                <CalendarMonthIcon fontSize="small" sx={{ mr: 1 }} />
                Application Deadline
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {formatDate(compensationAndDates?.applicationDeadline)}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
                <CalendarMonthIcon fontSize="small" sx={{ mr: 1 }} />
                Joining Date
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {formatDate(compensationAndDates?.joiningDate)}
              </Typography>
            </Grid>
          </Grid>

          {/* Contact Info */}
          {/* <Box mb={3}>
            <Typography variant="subtitle2" fontWeight="bold" color="text.primary">
              <ContactMailIcon fontSize="small" sx={{ mr: 1 }} />
              Contact
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Name: {contactInformation?.contactName}
            </Typography>
             <Typography variant="body2" color="text.secondary">
              Email: ({contactInformation?.contactEmail})
            </Typography>
             <Typography variant="body2" color="text.secondary">
              Phone: ({contactInformation?.contactPhone})
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Linkedin Profile: ({contactInformation?.linkedInProfile})
            </Typography>
          </Box> */}

          {/* Actions */}
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
            <Button variant="outlined" color="secondary" onClick={onClose}>
              Close
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
  );
};

export default OpportunityModal;
